var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_100",
    "data-name": "Elipse 100",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0bce63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointVerde);
export default __webpack_public_path__ + "static/media/point-verde.5f48520ffea0b1743d7c3c386fc4e487.svg";
export { ForwardRef as ReactComponent };